export default __webpack_public_path__ + "static/Blitz18 01F3F936-36acea2d76411cab96b85e9baabc8c16.jpg";